import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import SparkMD5 from 'spark-md5';
import { request } from './index';

function _readAsArrayBuffer(file) {
  var reader = new FileReader();
  return new Promise(function (resolve, reject) {
    reader.onload = function (e) {
      resolve(e.target.result);
    };

    reader.readAsArrayBuffer(file);
  });
}

function _getFileChecksum(_x) {
  return _getFileChecksum2.apply(this, arguments);
}

function _getFileChecksum2() {
  _getFileChecksum2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(file) {
    var CHUNK_SIZE, md5, start, end, fileBuffer;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            CHUNK_SIZE = 2097152; // Read in chunks of 2MB

            md5 = new SparkMD5.ArrayBuffer();
            start = 0;

          case 3:
            if (!(start < file.size)) {
              _context.next = 12;
              break;
            }

            end = start + CHUNK_SIZE >= file.size ? file.size : start + CHUNK_SIZE;
            _context.next = 7;
            return _readAsArrayBuffer(file.slice(start, end));

          case 7:
            fileBuffer = _context.sent;
            md5.append(fileBuffer);
            start = end;
            _context.next = 3;
            break;

          case 12:
            return _context.abrupt("return", md5.end(true));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _getFileChecksum2.apply(this, arguments);
}

function _parseFile(_x2, _x3) {
  return _parseFile2.apply(this, arguments);
}

function _parseFile2() {
  _parseFile2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(file, sanitize) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = sanitize(file.name);
            _context2.t1 = file.size;
            _context2.t2 = btoa;
            _context2.next = 5;
            return _getFileChecksum(file);

          case 5:
            _context2.t3 = _context2.sent;
            _context2.t4 = (0, _context2.t2)(_context2.t3);
            _context2.t5 = file.type;
            return _context2.abrupt("return", {
              filename: _context2.t0,
              byte_size: _context2.t1,
              checksum: _context2.t4,
              content_type: _context2.t5
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _parseFile2.apply(this, arguments);
}

function _signBlob(_x4, _x5) {
  return _signBlob2.apply(this, arguments);
}

function _signBlob2() {
  _signBlob2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(signingUrl, blob) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return request('POST', signingUrl, {
              blob: blob
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _signBlob2.apply(this, arguments);
}

function _directUpload(_x6, _x7, _x8) {
  return _directUpload2.apply(this, arguments);
}

function _directUpload2() {
  _directUpload2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(blobSignature, file, onProgress) {
    var _blobSignature$direct, url, headers;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _blobSignature$direct = blobSignature.direct_upload, url = _blobSignature$direct.url, headers = _blobSignature$direct.headers;
            _context4.next = 3;
            return request('PUT', url, file, {
              headers: headers,
              onProgress: onProgress
            });

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _directUpload2.apply(this, arguments);
}

export default function uploadFile(_x9, _x10) {
  return _uploadFile.apply(this, arguments);
}

function _uploadFile() {
  _uploadFile = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(file, signingUrl) {
    var extra,
        sanitize,
        onProgress,
        blob,
        signingResult,
        result,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            extra = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            sanitize = extra.sanitize, onProgress = extra.onProgress;
            _context5.next = 4;
            return _parseFile(file, sanitize ? sanitize : function (x) {
              return x;
            });

          case 4:
            blob = _context5.sent;
            _context5.next = 7;
            return _signBlob(signingUrl, blob);

          case 7:
            signingResult = _context5.sent;
            _context5.next = 10;
            return _directUpload(signingResult, file, onProgress ? onProgress : null);

          case 10:
            result = _context5.sent;
            return _context5.abrupt("return", {
              blob: blob,
              signingResult: signingResult,
              result: result
            });

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));
  return _uploadFile.apply(this, arguments);
}